import React from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, InputAdornment, TextField, FormControl, FormLabel } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';
import DecimalFormat from 'src/components/common/DecimalFormat';
import OperatorSelect from 'src/components/common/OperatorSelect';
import ValidityAdornment from './ValidityAdornment';

// labelCmp endAdornment startAdornment
const IntegerBoundRecipeFieldRender = ({
  fieldConfig,
  onChange,
  removeLine,
  removable,
  onOperatorChange,
  classes,
  validity,
  disabled,
}) => {
  const { t } = useTranslation();
  return (
    <FormControl required={fieldConfig.model.mandatory}>
      <div className={classes.fieldContainer}>
        <ValidityAdornment validity={validity} required={fieldConfig.model.mandatory} />
        <FormLabel
          style={{
            display: 'flex',
            alignItems: 'center',
            fontSize: '0.875rem',
          }}
          component="div"
        >
          {t(`smartmessaging.recipeFieldName.${fieldConfig.model.key}`)}
        </FormLabel>
        <div style={{ marginLeft: '16px', marginRight: '16px', display: 'flex' }}>
          <OperatorSelect
            fieldConfig={fieldConfig}
            onChange={onOperatorChange}
            disabled={disabled}
          />
        </div>
        <div style={{ width: '100%', display: 'flex' }}>
          <div style={{ display: 'flex' }}>
            <TextField
              disabled={disabled}
              style={{ flex: '1' }}
              onChange={event => {
                const val = [
                  event.target.value,
                  (fieldConfig.value &&
                    fieldConfig.value.values &&
                    fieldConfig.value.values.length > 1 &&
                    fieldConfig.value.values[1]) ||
                    '',
                ];
                onChange(fieldConfig, val);
              }}
              value={
                (fieldConfig.value &&
                  fieldConfig.value.values &&
                  fieldConfig.value.values.length &&
                  fieldConfig.value.values[0]) ||
                ''
              }
              InputProps={{ inputComponent: DecimalFormat, 'aria-label': 'Description' }}
            />
            <InputAdornment position="start">{t('smartmessaging.inputs.AND')}</InputAdornment>
            <TextField
              disabled={disabled}
              style={{ flex: '1' }}
              onChange={event => {
                const val = [
                  (fieldConfig.value &&
                    fieldConfig.value.values &&
                    fieldConfig.value.values.length &&
                    fieldConfig.value.values[0]) ||
                    '',
                  event.target.value,
                ];
                onChange(fieldConfig, val);
              }}
              value={
                (fieldConfig.value &&
                  fieldConfig.value.values &&
                  fieldConfig.value.values.length > 1 &&
                  fieldConfig.value.values[1]) ||
                ''
              }
              InputProps={{ inputComponent: DecimalFormat, 'aria-label': 'Description' }}
            />
          </div>
          {removable && (
            <InputAdornment position="start">
              <IconButton aria-label="clear" onClick={() => removeLine(fieldConfig)} size="large">
                <DeleteIcon />
              </IconButton>
            </InputAdornment>
          )}
        </div>
      </div>
    </FormControl>
  );
};

IntegerBoundRecipeFieldRender.propTypes = {
  fieldConfig: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  removeLine: PropTypes.func.isRequired,
  removable: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  onOperatorChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  validity: PropTypes.object.isRequired,
};

export default IntegerBoundRecipeFieldRender;
